import React from 'react';
import { Reveal } from './Reveal';
import { BookButton } from './BookButton';
import { steps } from '../data/homepage';
export function HowItWorks() {
  return <section id="how-it-works" aria-labelledby="how-heading" className="bg-navy py-24 text-paper md:py-32" data-id="element-59" data-mp="7qiopis3em7k">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-60" data-mp="3u03gpbjptrmz">
        <Reveal className="max-w-3xl" data-id="element-61" data-mp="3u0v43z35sj26">
          <h2 id="how-heading" className="font-serif text-4xl font-semibold leading-tight md:text-5xl" data-id="element-62" data-mp="3u1wmkomi87tx">
            How it works
          </h2>
          <p className="mt-6 text-lg text-paper/80 md:text-xl" data-id="element-63" data-mp="qibjniqq2hhx">Four steps. We're with you for every one.</p>
        </Reveal>

        <ol className="relative mt-16 grid gap-12 lg:grid-cols-4 lg:gap-10" data-id="element-64" data-mp="crpwviy5dner">
          {/* Gold connecting line: vertical on mobile, horizontal on desktop */}
          <span aria-hidden="true" className="absolute bottom-8 left-7 top-8 w-px bg-gold/60 lg:hidden" data-id="element-65" data-mp="14iw1abkwi79u" />
          <span aria-hidden="true" className="absolute left-[calc(12.5%-1.25rem)] right-[calc(12.5%-1.25rem)] top-7 hidden h-px bg-gold/60 lg:block" data-id="element-66" data-mp="19a4elipcqcsa" />
          {steps.map((step, i) => <li key={step.title} className="relative" data-id="element-67" data-mp="2mo5xwc0avi20" data-mpi={i}>
              <Reveal delay={i * 0.06} className="flex gap-6 lg:flex-col lg:items-center lg:text-center" data-id="element-68" data-mp="31b7l0ur352yj">
                <span className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-gold bg-navy font-serif text-2xl font-semibold text-gold" data-id="element-69" data-mp="2wk8yvejf1and">
                  {i + 1}
                </span>
                <div data-id="element-70" data-mp="36a0vsfezmfv0">
                  <h3 className="font-serif text-2xl font-semibold leading-snug lg:mt-6" data-id="element-71" data-mp="36cn2kcu20rc6">{step.title}</h3>
                  <p className="mt-3 text-lg leading-relaxed text-paper/80" data-id="element-72" data-mp="3k7zajlx80eb1">{step.body}</p>
                </div>
              </Reveal>
            </li>)}
        </ol>

        <Reveal className="mt-16 flex justify-start lg:justify-center" data-id="element-73" data-mp="1pwu6igi81zv6">
          <BookButton data-id="element-74" data-mp="1ky99sr26hybh" />
        </Reveal>
      </div>
    </section>;
}